import React from "react"

interface ChatTextIconProps {
  color: string;
}

const ChatTextIcon: React.FC<ChatTextIconProps> = ({
  color = "currentColor",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9H16M8 12H16M8 15H11M21 12C21.0002 13.6112 20.568 15.1929 19.7483 16.58C18.9287 17.967 17.7517 19.1087 16.3402 19.8856C14.9288 20.6626 13.3347 21.0465 11.7242 20.9971C10.1138 20.9477 8.5462 20.467 7.185 19.605L3 21L4.395 16.815C3.64855 15.6355 3.18668 14.2986 3.0459 12.9099C2.90511 11.5211 3.08927 10.1187 3.58382 8.8134C4.07837 7.5081 4.86975 6.33573 5.8954 5.38895C6.92106 4.44216 8.15288 3.74692 9.4935 3.35818C10.8341 2.96944 12.2468 2.89785 13.6198 3.14907C14.9929 3.4003 16.2887 3.96745 17.4048 4.80569C18.5209 5.64394 19.4267 6.7303 20.0507 7.97892C20.6747 9.22753 20.9997 10.6042 21 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChatTextIcon
